export default __webpack_public_path__ + "static/media/gift-card-description.19ddce5b.jpg";